import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { NotificationManager } from 'react-notifications';

export default function InlineComment(props)
{
    const [comment_value, set_comment_value] = useState('');
    const handle_comment_change = (evt) =>
    {
        set_comment_value(evt.target.value);
    };

    const handle_comment_cancel = (evt) =>
    {
        props.on_cacnel(evt);
    };

    const handle_comment_post = (evt) =>
    {
        if(comment_value.trim().length > 0)
        {
            props.on_post(evt,
            {
                parent_type: props.parent_type,
                parent_id: props.parent_id,
                data: comment_value,
                title: uuidv4(),
                type: 'comment'
            });
            NotificationManager.success('Your comment has been added', 'Perfect!')
        }
        else
        {
            props.on_cacnel(evt);
        }
    }
    if(props.can_comment === false) return <></>
    return (
        <div className='add-comment-form'>
            <h3>Write your comment</h3>
            <textarea autoFocus value={comment_value} onChange={handle_comment_change} />
            <div>
                <a onClick={handle_comment_cancel}>Cancel</a>
                <button className='button button-primary button-small' onClick={handle_comment_post}>Add Comment</button>
            </div>
        </div>
    );
}